import Marquee from "react-fast-marquee";

const ITEMS = [
  "Precision Agriculture",
  "Water Conservation",
  "Higher Yield",
  "Fuel Efficiency",
  "Durable Construction",
  "Sustainable Farming",
  "Genuine Products",
  "Expert Guidance",
];

export default function EditorialMarquee() {
  return (
    <section data-testid="marquee" className="border-y border-brand-ink/10 bg-brand-cream py-6">
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="mx-12 inline-flex items-center gap-12">
            <span className="font-heading text-2xl sm:text-3xl uppercase tracking-tight text-brand-ink/80">{t}</span>
            <span className="size-2 rounded-full bg-brand-brown" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
